// @flow

export const savedHeartImage = '/images/favorites/heart-favorited.gif';
export const unsavedHeartImage = '/images/favorites/heart-not-favorited.gif';
export function itemIndexableSeries (series: string, metal: string) {
  return `${series}-${metal}`;
}
